export default __webpack_public_path__ + "static/media/Cat Cafe 1.162a09a2.png";